import React, {Fragment} from 'react';
import createForm from "./Form";
import TextInput from "../../form/TextInput";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {SplitButton} from "primereact/splitbutton";
import Dropzone from "react-dropzone";
import {fileUpload} from "../../../utils/request";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";
import {optionsTemplate} from "../../../utils/formatters";

const languages = {
    1: 'magyar', 
    2: 'angol', 
    3: 'német', 
    4: 'francia', 
    5: 'olasz', 
    6: 'spanyol'
};

class RuleBookForm extends React.Component {

    state = {
        defaultLanguageRole: 1
    }

    openDialog = () => {
        if (this.dropzoneRef) {
            this.dropzoneRef.open();
        }
    }

    onDrop = async (acceptedFiles) => {
        try {
            const response = await fileUpload({
                action: "Document.create",
                uploaded_file: acceptedFiles[0],
                data: {
                    field: 'documents',
                    component: this.props.componentConfig.componentname,
                    component_id: this.props.values[this.props.componentConfig.idfield],
                    language: this.state.defaultLanguageRole
                }
            });
            if (this.props.saveChanges) {
                this.props.saveChanges(this.props.name, response.data);
            }
            this.documents.refresh();
        } catch (e) {
            console.error(e);
        }
    }

    render() {

        const sortable = true;
        const filterable = true;

        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="title"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Cím"
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="category"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kategória"
                        />
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <Select
                                name="product"
                                objectValue={false}
                                label="Termék"
                                storeType="remote"
                                placeholder="Vonalkód vagy cím"
                                component="product"
                                value={this.props.values.product}
                                optionsTemplate={optionsTemplate("product")}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("player_number")}
                            name="player_number"
                            value={this.props.values.player_number}
                            label="Játékosok száma"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("playtime")}
                            name="playtime"
                            value={this.props.values.playtime}
                            saveChanges={this.props.setFieldValue}
                            label="Játékidő"
                        />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("age_group")}
                            name="age_group"
                            value={this.props.values.age_group}
                            saveChanges={this.props.setFieldValue}
                            label="Kor"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Dokumentumok</label>
                        {this.props.values[this.props.componentConfig.idfield] ? <Dropzone disableClick disabled={false} className="image-pool" ref={(node) => { this.dropzoneRef = node; }} onDrop={this.onDrop}>
                            <SelectorGrid
                                {...this.props.getFieldProps("documents")}
                                ref={(e) => this.documents = e}
                                disabled={false}
                                component="RuleBook"
                                name="documents"
                                parentid={this.props.values.id}
                                data={this.props.values}
                                className={"p-small-table"}
                                view={["filename", "path", "language"]}
                                addButton={false}
                                columns={{
                                    "filename": {
                                        header: 'Fájl név',
                                        width: 6,
                                        sortable,
                                        filterable
                                    },
                                    "language": {
                                        header: 'Nyelv', 
                                        width: 2, 
                                        sortable, 
                                        filterable,
                                        renderer: (v, rowData) => {
                                            return languages[rowData.language];
                                        }
                                    }
                                }}
                                pageSize={0}
                                componentConfig={this.props.componentConfig}
                                orderBy={{field: "filename", direction: "ASC"}}
                                paginatorRight={(props) => 
                                    <Fragment>
                                        <SplitButton
                                            onClick={this.openDialog}
                                            label={this.state.defaultLanguageRole === 1 ? "" : (languages[this.state.defaultLanguageRole || Object.keys(languages)[0]])}
                                            icon="fa fa-upload"
                                            model={Object.keys(languages || {}).map((key) => {
                                                return {
                                                    label: languages[key],
                                                    command: (e) => {
                                                        this.setState({defaultLanguageRole: key});
                                                    }
                                                }
                                            })}
                                            className="p-button-secondary"
                                            {...props}
                                        />
                                    </Fragment>}
                            />
                        </Dropzone> : <Fragment>Kérlek mentsd el a dokumentumok feltöltés előtt!</Fragment>}
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(RuleBookForm);
